import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LoadingIndicatorService } from '../../../services/loading-indicator/loading-indicator.service';
import { EventsService } from '../../../services/events/events.service';
import { BreadCrumbElement } from '../../../shared/entities/breadcrumb.element.entity';
import { FormControl, FormGroup } from '@angular/forms';
import { FormUtils } from '../../../shared/utils/form-utils';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { CurrencyCode } from '@tripbakers/enums';

@Component({
  selector: 'app-booking-payment',
  templateUrl: './booking-payment.component.html',
  styleUrls: ['./booking-payment.component.css']
})
export class BookingPaymentComponent implements OnInit, AfterViewInit {
  /* */
  public breadCrumbElements: Array<BreadCrumbElement> = [];

  /* */
  public backgroundImage = '/assets/media/photos/photo21@2x.jpg';
  public containerBackgroundImage = {'background-image': 'url(' + this.backgroundImage + ')'};
  public subContainerBackgroundImage = {};
  public containerClass = {'bg-image': true};
  public subContainerClass = {'bg-white-op-90': true};
  public contentClass: any = {'content': true, 'text-center': true, 'content-top': true};
  public pyClass = {'py-50': true};
  public h1class: any = {'h1': true};
  public h2class: any = {'h4': true};

  /* */
  public page = 1;
  public limit = 25;
  public section = 1;

  /* */
  public pagination: any;
  public elements;
  public form: FormGroup;

  public currencies = Object.values(CurrencyCode);

  constructor(private loadingIndicatorService: LoadingIndicatorService,
              private eventsService: EventsService,
              private activatedRoute: ActivatedRoute,
              private http: HttpClient) {

    /* */
    this.breadCrumbElements = [
      new BreadCrumbElement('tripmakery', 'javascript:void(0)'),
      new BreadCrumbElement('Bookings', 'javascript:void(0)'),
      new BreadCrumbElement('Payments Overview', 'javascript:void(0)')
    ];

    /* */
    this.form = new FormGroup({
      'date': new FormControl({value: '', disabled: false}),
      'id': new FormControl({value: '', disabled: false}),
      'username': new FormControl({value: '', disabled: false}),
      'paymentStateUser': new FormControl({value: '', disabled: false}),
      'payoutStatePartner': new FormControl({value: '', disabled: false}),
      'currency': new FormControl({value: '', disabled: false}),
      'sorting': new FormControl({value: '', disabled: false}),
      'bples_new': new FormControl({value: false, disabled: false}),
      'bples_user_payment_is_due': new FormControl({value: false, disabled: false}),
      'bples_partner_payment_is_due': new FormControl({value: false, disabled: false}),
      'bples_deadline_mismatch': new FormControl({value: false, disabled: false}),
      'bples_partner_missing_bank_details': new FormControl({value: false, disabled: false}),
      'bples_finished': new FormControl({value: false, disabled: false}),
      'bples_cancelled': new FormControl({value: false, disabled: false}),
    });

  }

  ngOnInit() {
    /* */
    this.eventsService.on('refreshBookingPaymentPartnerList', (bookingChangeRequestId) => {
      this.loadBookingPaymentList();
    });

    /* */
    this.loadBookingPaymentList();

  }

  ngAfterViewInit() {
    /* */
    if (this.activatedRoute.snapshot.queryParams['bookingId'] != null) {
      this.requestBookingPaymentDetails(this.activatedRoute.snapshot.queryParams['bookingId']);
    }
  }

  public loadBookingPaymentList() {
    this.loadingIndicatorService.showLoadingBar();

    /* Build params */
    let params = new HttpParams();
    params = params.append('page', this.page.toString());
    params = params.append('limit', this.limit.toString());

    params = params.append('date', FormUtils.returnAsNullIfEmpty(this.form.get('date').value) != null && this.form.get('date').value !== '' ? moment.utc(this.form.get('date').value).format('YYYY-MM-DD') : null);
    params = params.append('id', FormUtils.returnAsNullIfEmpty(this.form.get('id').value));
    params = params.append('username', FormUtils.returnAsNullIfEmpty(this.form.get('username').value));
    params = params.append('paymentStateUser', FormUtils.returnAsNullIfEmpty(this.form.get('paymentStateUser').value));
    params = params.append('payoutStatePartner', FormUtils.returnAsNullIfEmpty(this.form.get('payoutStatePartner').value));
    params = params.append('currency', FormUtils.returnAsNullIfEmpty(this.form.get('currency').value));
    params = params.append('sort', FormUtils.returnAsNullIfEmpty(this.form.get('sorting').value));

    /* Remove empty params */
    let paramsFinal = new HttpParams();
    for (const paramsKey of params.keys()) {
      if (params.get(paramsKey) != null && params.get(paramsKey).trim() != '') {
        paramsFinal = paramsFinal.append(paramsKey, params.get(paramsKey));
      }
    }

    /* Create array params */
    const stateFields = ['bples_new', 'bples_user_payment_is_due', 'bples_partner_payment_is_due', 'bples_deadline_mismatch', 'bples_partner_missing_bank_details', 'bples_finished', 'bples_cancelled'];
    for (const stateField of stateFields) {
      const val = FormUtils.returnAsNullIfFalse(this.form.get(stateField).value);
      if (val == null) {
        continue;
      }

      paramsFinal = paramsFinal.append('states[]', stateField.replace('bples_', '').toUpperCase());
    }

    /* Send Request and map data */
    this.http.get(environment.urls.service + '/api/v1/authenticated/admin/booking/payments', {params: paramsFinal})
      .subscribe((response: any) => {

          /* Date Mapping */
          for (const element of response.elements) {
            element.created = moment.utc(element.created).format('YYYY-MM-DD');
            element.deadlineCancellation = moment.utc(element.deadlineCancellation).format('YYYY-MM-DD');
            element.deadlineUser = moment.utc(element.deadlineUser).format('YYYY-MM-DD');
            element.deadlinePartner = moment.utc(element.deadlinePartner).format('YYYY-MM-DD');
            element.checkIn = moment.utc(element.checkIn).format('YYYY-MM-DD');
            element.bookingDate = moment.utc(element.bookingDate).format('YYYY-MM-DD');
          }

          this.elements = response.elements;
          this.pagination = response.pagination;

        },
        error => {
          if (error.error === 'Unauthorized') {
          }
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        },
        () => {
          this.loadingIndicatorService.hideLoadingBar();
        }
      );
  }

  public requestBookingPaymentDetails(id: string) {
    this.eventsService.broadcast('requestShowModalBookingPaymentDetails', id);
  }

  public sendPage(e: number) {
    this.page = e;
    this.loadBookingPaymentList();
  }
}
